<div *ngIf="loading" class="loading-text">
  <p>{{ 'PleaseWaitDataLoading' | translate }}</p>
</div>

<div *ngIf="!loading">
<app-sub-header [pageTitle]="'Tour' | translate"></app-sub-header>

        <div class="padded-container" *ngIf="routeResponse?.routes">
          <div *ngFor="let routeItem of routeResponse?.routes">
            <dx-button
              class="full-width-button"
              text="{{ routeItem.description }}"
              type="default"
              (onClick)="continueNextStep(routeItem.id)">
            </dx-button>
          </div>
        
        <dx-button
          class="full-width-button"
          text="{{ 'Back' | translate }}"
          type="default"
          (onClick)="navigateToPickClient()">
        </dx-button>
      </div>
    </div>